import { Box } from '@mui/material'
import get from 'lodash/get'

import AdvancedTextField from './AdvancedTextField'
import { useCommonStyles } from '../config/theme'

const AdvancedUrlField = ({ record = {}, text, ...props }) => {
  const commonClasses = useCommonStyles()
  const value = get(record, props.source)
  return value ? (
    <Box component="a" href={value} sx={commonClasses.link} target="_blank" rel="noopener noreferrer">
      <AdvancedTextField {...props} record={{ ...record, [props.source]: text || value }} />
    </Box>
  ) : (
    <AdvancedTextField {...props} />
  )
}

export default AdvancedUrlField
